module.exports = __webpack_public_path__ + "static/media/vm_icon.ebd71a5b.png";